import React from 'react';

const NoDataFound = () => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center p-4 gap-0'>
      <svg
        width='107'
        height='136'
        viewBox='0 0 107 136'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='53.2918' cy='52.7918' r='52.7918' fill='#F1F1F1' />
        <rect
          x='32.8304'
          y='51.9885'
          width='51.1609'
          height='71.8346'
          rx='7'
          transform='rotate(2.5 32.8304 51.9885)'
          fill='#EEEEEE'
          stroke='#999999'
        />
        <rect
          x='1.56162'
          y='47.1623'
          width='55.1609'
          height='75.8346'
          rx='9'
          transform='rotate(-7.5 1.56162 47.1623)'
          fill='#FAFAFA'
          stroke='#999999'
        />
        <path
          d='M3.7278 55.9547C3.1511 51.5743 6.23467 47.5557 10.6152 46.979L47.4582 42.1285C51.8386 41.5518 55.8572 44.6354 56.4339 49.0158L57.6063 57.921L4.90018 64.8599L3.7278 55.9547Z'
          fill='#EEEEEE'
        />
        <rect
          x='66.8516'
          y='43.2989'
          width='2.21504'
          height='7.38346'
          rx='1.10752'
          transform='rotate(82.5 66.8516 43.2989)'
          fill='#999999'
        />
        <rect
          x='46.625'
          y='31.0676'
          width='2.21504'
          height='7.38346'
          rx='1.10752'
          transform='rotate(-7.5 46.625 31.0676)'
          fill='#999999'
        />
        <rect
          x='59.6016'
          y='33.0825'
          width='2.21504'
          height='7.38346'
          rx='1.10752'
          transform='rotate(37.5 59.6016 33.0825)'
          fill='#999999'
        />
        <rect
          x='10.4102'
          y='67.1134'
          width='42.8241'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 10.4102 67.1134)'
          fill='#DCDCDC'
        />
        <rect
          x='12.3359'
          y='81.754'
          width='42.8241'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 12.3359 81.754)'
          fill='#DCDCDC'
        />
        <rect
          x='14.2656'
          y='96.3945'
          width='42.8241'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 14.2656 96.3945)'
          fill='#DCDCDC'
        />
        <rect
          x='11.1797'
          y='72.9696'
          width='15.5053'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 11.1797 72.9696)'
          fill='#EEEEEE'
        />
        <rect
          x='13.1094'
          y='87.6102'
          width='15.5053'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 13.1094 87.6102)'
          fill='#EEEEEE'
        />
        <rect
          x='15.0352'
          y='102.251'
          width='15.5053'
          height='2.95338'
          rx='1.47669'
          transform='rotate(-7.5 15.0352 102.251)'
          fill='#EEEEEE'
        />
      </svg>
      <h5 className='text-center text-muted m-0'>No Data Available!</h5>
      <p className='text-center text-muted'>
        Please check back later for updates.
      </p>
    </div>
  );
};

export default NoDataFound;
